import React, { useEffect, useState } from "react";
import SingleCompanyCard from "../../../components/items/SingleCompanyCard ";
import Button from "../../form/front/Button";
import Select from "../../form/front/Select";
import SearchWithDropdown from "../../form/front/SearchWithDropdown";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { jobDetailsUser, jobUserList } from "../../../services/postService";
import Modal from "../../elements/front/Modal";
import Input from "../../form/front/Input";
import Textarea from "../../form/front/Textarea";
import CompanyDetailsCard from "./CompanyDetailsCard.js";
import JobDetailsSkeleton from "../../skeleton/JobDetailsSkeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import DatePicker from "../../form/DatePicker";
import Checkbox from "../../form/front/Checkbox";
import Radio from "../../form/front/Radio";
import FileUploadSingle from "../../form/FileUploadSingle";
import useForm from "../../../hooks/useForm";
import { applyJob } from "../../../services/applicationService";
import { toast } from "react-toastify";
import { formValidate } from "../../../helpers/formValidate";
import Form from "../../form/Form";
import { taxonomyList } from "../../../services/taxonomyService";
import { useDebounce } from "../../../hooks/useDebounce";
import PaginationPage from "../../common/Pagination";
import {
  organizationDetailsUser,
  organizationFrontList,
} from "../../../services/organizationService";

const CompanySection = () => {
  const [gender, setGender] = useState("male");
  const [agree, setAgree] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isState, setisState] = useState(null);
  const [selectSort, setSelectSort] = useState(null);
  const [experience, setExperience] = useState(null);
  const [companyType, setCompanyType] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [salary, setSalary] = useState(null);
  const [skills, setSkills] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [eeo, setEeo] = useState([]);
  const [sex, setSex] = useState("");
  const [veteranStatus, setVeteranStatus] = useState("");
  const [disability, setDisability] = useState("");

  /* ---------------- JOB SEARCH STATE ---------------- */
  const [keyword, setKeyword] = useState("");
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  /* ---------------- COUNTRY / STATE SEARCH STATE ---------------- */
  const [countryKeyword, setCountryKeyword] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  /* ---------------- RESPONSIVE DETECTION ---------------- */
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  /* ---------------- STATIC COUNTRY / STATE DATA ---------------- */
  const countryStateData = [
    { _id: "c1", type: "list", name: "India" },
    { _id: "c2", type: "list", name: "United States" },
    { _id: "c3", type: "list", name: "United Kingdom" },
    { _id: "c4", type: "list", name: "Canada" },
    { _id: "c5", type: "list", name: "Australia" },
    { _id: "c6", type: "list", name: "California, USA" },
    { _id: "c7", type: "list", name: "New York, USA" },
    { _id: "c8", type: "list", name: "Maharashtra, India" },
    { _id: "c9", type: "list", name: "Karnataka, India" },
  ];

  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();

  const [filters, setFilters] = useState({
    limit: 20,
    page: 1,
    sortQuery: "-createdAt",
  });
  const { data, isLoading, isError, error, isFetching } = useQuery({
    queryKey: ["company-list", filters, keyword],
    queryFn: async () => {
      const res = await organizationFrontList({
        ...filters,
        ...(keyword && { keyword }),
      });
      if (res?.status !== 200) toast.warning(res?.message);
      return res;
    },
    keepPreviousData: true,
  });
  const companies = data?.docs?.data || [];
  const paginationMeta = data?.docs?.metadata;

  const totalPages = paginationMeta?.totalPages || 1;

  // Pagination component is ZERO-based
  const currentPage = (paginationMeta?.page || 1) - 1;

  const handlePageChange = ({ selected }) => {
    setFilters((prev) => ({ ...prev, page: selected + 1 }));
  };

  useEffect(() => {
    if (companies.length > 0) {
      if (
        !selectedCompany ||
        !companies.find((company) => company._id === selectedCompany.id)
      ) {
        const firstCompany = companies[0];

        setSelectedCompany({
          id: firstCompany._id,
          name: firstCompany.content?.en?.title,
          description: firstCompany.content?.en?.content,
          logo: firstCompany.logo?.url,
        });
      }
    } else {
      setSelectedCompany(null);
    }
  }, [companies]);

  /* ---------------- SELECTED JOB DETAILS ---------------- */
  const { data: companyDetails, isLoading: isDetailsLoading } = useQuery({
    queryKey: ["company-details", selectedCompany?.id],
    queryFn: async () => {
      if (!selectedCompany?.id) return null;
      const res = await organizationDetailsUser({
        id: selectedCompany.id, // ✅ sending _id now
      });
      return res;
    },
    enabled: !!selectedCompany?.id,
  });

  /* ---------------- JOB FILTER LOGIC ---------------- */
  // useEffect(() => {
  //   if (!keyword) {
  //     setFilteredJobs([]);
  //     return;
  //   }

  //   // const filtered = searchJobsData.filter((job) =>
  //   //   job.name.toLowerCase().includes(keyword.toLowerCase()),
  //   // );
  // }, [keyword]);

  /* ---------------- COUNTRY FILTER LOGIC ---------------- */
  useEffect(() => {
    if (!countryKeyword) {
      setFilteredCountries([]);
      return;
    }

    const filtered = countryStateData.filter((item) =>
      item.name.toLowerCase().includes(countryKeyword.toLowerCase()),
    );

    setFilteredCountries(filtered);
  }, [countryKeyword]);
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page: 1,
    }));
  }, [search, experience, jobType, salary, skills]);

  const handleCompanySelect = (company) => {
    setSelectedCompany(company);
  };

  const handleCountrySelect = (item) => {
    setSelectedCountry(item);
    setCountryKeyword(item?.name || "");
  };

  const sortOptions = [
    { value: "-createdAt", name: "Latest" },
    { value: "+createdAt", name: "Oldest" },

    { value: "+content.en.title", name: "A-Z" },
    { value: "-content.en.title", name: "Z-A" },
  ];

  const { data: jobExperienceData } = useQuery({
    queryKey: ["experience"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 100,
        type: "experience",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const jobTypeOptions = [
    { value: "full-time", name: "Full Time" },
    { value: "part-time", name: "Part Time" },
    { value: "contract", name: "Contract" },
    { value: "internship", name: "Internship" },
    { value: "remote", name: "Remote" },
  ];

  const { data: salaryData } = useQuery({
    queryKey: ["salary"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "salary-range",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });
  const salaryOptions = salaryData?.data?.map((item) => {
    const unitSymbol = item?.range?.unit === "usd" ? "$" : "₹";

    const formatValue = (val) => (val >= 1000 ? `${val / 1000}k` : val);

    return {
      name: `${unitSymbol}${formatValue(item?.range?.min)} - ${unitSymbol}${formatValue(item?.range?.max)}`,
      value: item?._id,
    };
  });

  const { data: jobSkillData } = useQuery({
    queryKey: ["skill"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "skill",
      });

      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });
  const InlineSpinner = () => (
    <i className="fa-solid fa-spinner-third animate-spin text-gray-400 ml-2" />
  );

  /* ---------------- RENDER JOB CARDS ---------------- */
  const renderJobCards = () => {
    if (isLoading) {
      return (
        <div className="space-y-4">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
            <JobCardSkeleton key={item} />
          ))}
        </div>
      );
    }

    if (isError) {
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-red-50 rounded-lg">
          <i className="fa-solid fa-circle-exclamation text-4xl text-red-500 mb-3"></i>
          <h3 className="text-lg font-semibold text-red-700 mb-1">
            Error Loading Companies
          </h3>
          <p className="text-sm text-red-600 text-center">{error.message}</p>
        </div>
      );
    }

    if (companies.length === 0) {
      return (
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-slate-50 dark:bg-white/10 dark:border dark:border-gray-500 rounded-lg">
          <i className="fa-solid fa-briefcase text-4xl text-slate-300 dark:text-gray-300 mb-3"></i>
          <h3 className="text-lg font-semibold text-slate-700 dark:text-gray-200 mb-1">
            No Company Found
          </h3>
          <p className="text-sm text-slate-500 dark:text-gray-300 text-center"></p>
        </div>
      );
    }

    // Render with Swiper for mobile/tablet (<=1024px)
    if (isMobile) {
      return (
        <div className="job-swiper-container">
          <Swiper
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            spaceBetween={16}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            mousewheel={{
              forceToAxis: true,
            }}
            keyboard={{
              enabled: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1.5,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            }}
            className="pb-12"
          >
            {companies.map((company) => (
              <SwiperSlide key={company._id}>
                <SingleCompanyCard
                  data={{
                    id: company._id,
                    name: company.content?.en?.title || company.name,
                    description: company.content?.en?.content || "",
                    logo: company.logo?.url,
                    jobCount: company.jobData || 0,
                  }}
                  onClick={handleCompanySelect}
                  isSelected={selectedCompany?.id === company._id}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Buttons */}
          <div className="flex items-center justify-center gap-4 mt-4">
            <button className="swiper-button-prev-custom w-10 h-10 rounded-full bg-palatte text-white flex items-center justify-center hover:bg-palatte/90 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button className="swiper-button-next-custom w-10 h-10 rounded-full bg-palatte text-white flex items-center justify-center hover:bg-palatte/90 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      );
    }

    // Render normal list for desktop (>1024px)
    return (
      <div className="space-y-5">
        {companies.map((company) => (
          <SingleCompanyCard
            key={company._id}
            data={{
              id: company._id,
              name: company.content?.en?.title || company.name,
              description: company.content?.en?.content || "",
              logo: company.logo?.url,
              jobCount: company.jobData || 0,
            }}
            onClick={handleCompanySelect}
            isSelected={selectedCompany?.id === company._id}
          />
        ))}
      </div>
    );
  };

  const handleResetFilters = () => {
    // Reset search input
    setKeyword("");
    //  setSearch(""); // if you want to reset debounced keyword
    setCountryKeyword("");
    setSelectedCountry(null);

    // Reset filters
    setExperience(null);
    setCompanyType(null);
    setJobType(null);
    setSalary(null);
    setSkills(null);
    setSelectSort(null);

    // Reset query filters
    setFilters({
      limit: 20,
      page: 1,
      sortQuery: "-createdAt",
    });
  };

  return (
    <>
      <section className="pt-5 pb-10 md:pb-14 xls:pb-28 bg-white dark:bg-darkBg relative w-full px-4 lg:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto rounded-t-3xl -mt-40">
        <div className="px-0 md:px-7 py-4 md:py-7 space-y-4">
          <div className="relative shadow-md rounded-lg py-3 flex flex-col md:flex-row justify-between items-center gap-x-4 border border-slate-200 dark:border-gray-700 dark:bg-gray-700 px-2 md:px-4 divide-y md:divide-y-0 divide-slate-200">
            <div className="flex-shrink flex-grow w-full ">
              <SearchWithDropdown
                placeholder="Search Companies"
                // dropdownData={[]}
                keyword={keyword}
                setKeyword={setKeyword}
                // onChange={handleJobSelect}
                xPlacement="bottom"
                // dropdownClass="bg-white rounded"
                divClasses="border-0 dark:text-gray-100"
                inputClasses="pr-24"
                icon="fa-light fa-search"
                iconClasses="text-black text-lg md:text-2xl dark:text-gray-100"
              />
            </div>
            {/* 
            <div className="flex-shrink flex-grow w-full">
              <SearchWithDropdown
                placeholder="Country or state"
                dropdownData={filteredCountries}
                keyword={countryKeyword}
                setKeyword={setCountryKeyword}
                onChange={handleCountrySelect}
                xPlacement="bottom"
                dropdownClass="bg-white rounded"
                divClasses="border-0"
                inputClasses="pr-0 md:pr-24"
                icon="fa-light fa-location-dot"
                iconClasses="text-black text-lg md:text-2xl"
              />
            </div> */}

            {/* <div className="relative md:absolute right-0 md:right-4 w-full md:w-auto">
              <Button
                buttonLabel="Search"
                buttonLabelClasses="text-base md:text-xl group-hover:text-palatte"
                buttonClasses="w-full md:w-auto h-10 md:h-14 rounded bg-palatte px-7 border border-palatte hover:bg-transparent group"
              />
            </div> */}
          </div>
        </div>

        {/* ---------------- CONTENT GRID ---------------- */}
        <div className="grid grid-cols-1 xls:grid-cols-2 gap-8">
          <div className="space-y-5">
            <div className="flex flex-col md:flex-row items-start gap-2 md:items-center justify-between">
              <div className="flex-shrink-0 flex-grow-0">
                <div className="flex items-center gap-2 justify-end"></div>
              </div>
            </div>

            {renderJobCards()}
            {totalPages > 1 && (
              <PaginationPage
                pageCount={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          {/* {isLoading || isFetching ? (
  <JobDetailsSkeleton /> // loader while list is fetching/filtering
) : jobsData.length === 0 ? (
  <JobDetailsCard jobDetails={null} /> // No jobs in list
) : isDetailsLoading ? (
  <JobDetailsSkeleton /> // loader while selected job details are fetching
) : (
  <JobDetailsCard
    jobDetails={jobDetails}
    onApplyClick={() => setIsModalOpen(true)}
  />
)} */}

          <div className="relative">
            <div className="px-4 md:px-7 py-4 md:py-7 border border-slate-200 dark:border-gray-500 dark:bg-white/10 rounded-xl md:rounded-3xl overflow-hidden sticky top-28">
              {isDetailsLoading || isLoading || isFetching ? (
                <JobDetailsSkeleton />
              ) : (
                <CompanyDetailsCard
                  company={companyDetails}
                  onApplyClick={() => setIsModalOpen(true)}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const JobCardSkeleton = () => {
  return (
    <div className="animate-pulse p-4 border border-slate-200 rounded-lg">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-16 h-16 bg-slate-200 rounded-lg"></div>
        <div className="flex-grow space-y-2">
          <div className="h-5 bg-slate-200 rounded w-3/4"></div>
          <div className="h-4 bg-slate-200 rounded w-1/2"></div>
          <div className="h-3 bg-slate-200 rounded w-full"></div>
          <div className="flex gap-2 mt-2">
            <div className="h-6 bg-slate-200 rounded w-20"></div>
            <div className="h-6 bg-slate-200 rounded w-20"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySection;
